// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=2e2d6dc6-eccd-41d5-bd0f-0f13827f6f26";
};